import { mixpanel } from '@fiverr-private/obs';
import { MIXPANEL_EVENT_PROPERTIES, MIXPANEL_PAGE_NAMES } from '../../../../../shared/mixpanel';
import { getDataFromStores } from '../../../../../shared/utils';
import store from '../../store';

interface Payload {
    logoPosition: number;
    projectId: string;
    engineType: string;
}

export const reportViewMoreVariationsClicked = ({ logoPosition, projectId, engineType }: Payload) => {
    mixpanel.track('Logo Maker - Listing - View More Variations Clicked', {
        ...getDataFromStores(
            store.user,
            store.brief,
            store.briefSource,
            store.pagePath,
            store.statistics,
            store.referrer,
            store.fromBoost
        ),
        [MIXPANEL_EVENT_PROPERTIES.PAGE_NAME]: MIXPANEL_PAGE_NAMES.BUYER,
        [MIXPANEL_EVENT_PROPERTIES.PROJECT_ID]: projectId,
        [MIXPANEL_EVENT_PROPERTIES.LOGO_POSITION]: logoPosition,
        [MIXPANEL_EVENT_PROPERTIES.ENGINE_TYPE]: engineType,
    });
};
